export default "__VITE_ASSET__1aae9c03__"